import type { TagItem } from "@/types";

export function groupShoppingItems<T extends TagItem>(items: T[]) {
  const groups = new Map<string, { retailer: string; items: T[]; subtotal: number }>();
  for (const item of items) {
    const group = groups.get(item.retailer) || { retailer: item.retailer, items: [], subtotal: 0 };
    group.items.push(item);
    group.subtotal = Math.round((group.subtotal + item.price_gbp * (item.quantity ?? 1)) * 100) / 100;
    groups.set(item.retailer, group);
  }
  return [...groups.values()];
}
